import React, { Component } from 'react';
import * as Media from '../../utils/Breakpoints';
import classnames from 'classnames'
import withSizes from 'react-sizes';
import { TweenLite, Power4 } from "gsap"

import { 
  NavLink
} from 'react-router-dom';

import { Window, Slider, Image, Content, Grid, Item, Link, LazyImage, Carousel, Container} from '../../components';

class Blocks extends Component {

  oriArray=[];

	constructor(props) {
    super(props);
    

    this.state = {
      sliderActive: false,
      activeSlide: 0,
      nextSlide: 2,
      prevSlide: -1,
      sliderPos: 'start',

    }

    this._sliderIndex = this._sliderIndex.bind(this);    
    this._slider = this._slider.bind(this);
    this.checkKey = this.checkKey.bind(this);    

  }

  componentDidMount() {
      let _this = this;

     document.addEventListener('keydown', function(event) {
        
        if (event.keyCode == '37') {
            _this._sliderIndex('prev');
        } else if (event.keyCode == '39') {
            _this._sliderIndex('next');
        }

    }, false);
  }

	componentWillUnmount() {}

  checkKey = (e) => {

    console.log('event', e);
  }

  _sliderIndex = (action) => {
    let _this = this;
    let slidesLength = this.props.blockLength; 

    if( action == 'next' ) {

      if( this.state.activeSlide < (slidesLength-2) ) {
      
        this.setState({ activeSlide: this.state.activeSlide+1, sliderPos: "" });  
      
      } else {
      
        this.setState({ activeSlide: this.state.activeSlide, sliderPos: "end" });  
      
      }
      
    } else {

      if( this.state.activeSlide > 0 ) {
      
        this.setState({ activeSlide: this.state.activeSlide-1, sliderPos: "" });  
      
      } else {
      
        this.setState({ activeSlide: 0, sliderPos: "start" });  
      
      }

    };

    this.setState({ sliderActive : true }, () => { 

      let sliderPos;

      if(action == "next") {
           if( this.state.activeSlide == (slidesLength-2) ) {
            sliderPos = "end";
           }
      } else {
          if( this.state.activeSlide == 0 ) {
            sliderPos = "start";
          }
      }

      _this.setState({ nextSlide: this.state.activeSlide+2, prevSlide: this.state.activeSlide-1, sliderPos: sliderPos });

      _this._slider();

    });
    
    
    
 }

 _slider = () => {

  
    let slideDist = this.refs.sections.clientWidth/2;
    let activeSlide = this.state.activeSlide;
    let slideTo = activeSlide*slideDist;
    
    TweenLite.to(this.refs.sections, .3, { x: -slideTo });

 }



  render() {

    
    let { blocks, location, mod } = this.props;

    console.log(this.state.prevSlide, this.state.activeSlide, this.state.nextSlide);
    
   
    const blockSwitch = blocks.map(( b, ix ) => { 

      let type = b.acf_fc_layout;

      switch(type) {

        case "text_block":

          let nextIndex = (this.state.nextSlide == ix) ? "next" : "";
          let prevIndex = (this.state.prevSlide == ix ) ? "prev" : "";

          return( 
           
              <div className={"Template-slider-section  Template-slider-section--text "+nextIndex+" "+prevIndex } key={ix}>

                <div className="Section  Section--text">

                  <div className="Section-content">
                      
                    <div className="Section-body">
                      <Content modifier={mod} html={b.text} />
                    </div>
                 
                 </div>

                 </div>
          
              </div> 
          );
        
        break;

        case "image_block":

          let next = (this.state.nextSlide == ix) ? "next" : "";
          let prev = (this.state.prevSlide == ix ) ? "prev" : "";

          return( 
           
              <div className={"Template-slider-section  Template-slider-section--image "+next+" "+prev } key={ix}>

                <div className="Section  Section--image">

                  <div className="Section-content">
                      
                   <LazyImage src={b.image.sizes.mancoba_medium} ratio={false} className={"padded"} /> 
                 
                 </div>

                 <div className="Section-foot">
                   <Content html={"<p>"+b.image.caption+"</p>"} modifier={"caption"} />
                 </div>

                 </div>

              </div> 
          );
        
        break;

        default:
          return null;
      }

    })

    return (
      

      <div className={"Template-slider  Template-slider--"+this.state.sliderPos}>

          <div className="Template-slider-container">
            
            <Container>
            <div className={"Template-slider-sections"} ref="sections">

               {blockSwitch}
       
            </div>
            </Container>

          </div>

          <div className={"Template-slider-controls  Template-slider-controls--"+this.state.sliderPos}>
            <div className="Template-slider-prev" onClick={ () => { this._sliderIndex('prev') }} ><span>Prev</span></div>
            <div className="Template-slider-next" onClick={ () => { this._sliderIndex('next') }} ><span>Next</span></div>
          </div>

        </div>
    );
  }
}

const mapSizesToProps = ({ width, height }) => ({
  isMobile: width < 480
})

export default withSizes(mapSizesToProps)(Blocks);



// WEBPACK FOOTER //
// ./src/js/components/Sections/Sections.jsx